import { Button, ConfigProvider } from 'antd'
import useGlobalStore from '@/store'
import { useShallow } from 'zustand/react/shallow'

const ExtraButton = props => {
  const { onClick, icon, children } = props
  const { theme } = useGlobalStore(
    useShallow((state: any) => ({
      theme: state.theme,
    }))
  )
  return (
    <ConfigProvider
      theme={{
        token: {
          colorText: theme?.token?.colorPrimary,
        },
      }}
    >
      <Button
        type="text"
        size="small"
        ghost
        style={{ marginRight: -7 }}
        icon={icon}
        onClick={onClick}
      >
        {children}
      </Button>
    </ConfigProvider>
  )
}

export default ExtraButton
